import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=2bce2984&scoped=true&"
import script from "./ThemeToggle.vue?vue&type=script&lang=js&"
export * from "./ThemeToggle.vue?vue&type=script&lang=js&"
import style0 from "./ThemeToggle.vue?vue&type=style&index=0&id=2bce2984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce2984",
  null
  
)

export default component.exports